import { defineStore } from 'pinia';

export const useRouterHistory = defineStore('routerHistory', {
  actions: {
    setPreviousRoute(route) {
      if (this.previousRoutes.length >= 5) {
        this.previousRoutes.shift();
      }
      this.previousRoutes.push(route);
    },
  },
  state: () => ({
    previousRoutes: [] as string[],
  }),
});
